export const INIT_HOMEPAGE = 'INIT_HOMEPAGE';
export const INIT_ABOUTUS = 'INIT_ABOUTUS';
export const INIT_NEWS_EVENT = 'INIT_NEWS_EVENT';
export const INIT_PRODUCTS = 'INIT_PRODUCTS';
export const INIT_ALL_PAGE = 'INIT_ALL_PAGE';
export const INIT_SETTINGS = 'INIT_SETTINGS';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const GET_INSTAGRAM = 'GET_INSTAGRAM';

export const INIT_ALL_PAGE_TH = 'INIT_ALL_PAGE_TH';
export const INIT_NEWS_EVENT_TH = 'INIT_NEWS_EVENT_TH';
export const INIT_PRODUCTS_TH = 'INIT_PRODUCTS_TH';



// WEBPACK FOOTER //
// ./src/actions/actionType.js